import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [editDropdownOpen, setEditDropdownOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => {
    setIsOpen(false);
    setEditDropdownOpen(false);
  };

  const toggleEditDropdown = () => {
    setEditDropdownOpen(!editDropdownOpen);
  };

  return (
    <>
      <div className="hamburger" onClick={toggleSidebar}>
        &#9776;
      </div>

      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <h2 className="sidebar-title" style={{color:"white"}}> <Link to="/" onClick={closeSidebar}> IEPL @ 2025 </Link></h2>
        <ul className="nav-list">
          <li><Link to="/material-calculator" onClick={closeSidebar}>Material Calculator</Link></li>
          <li><Link to="/quotation-builder" onClick={closeSidebar}>Quotation Builder</Link></li>

          <li className="dropdown">
            <button className="dropdown-btn" onClick={toggleEditDropdown}>
              Edits
            </button>

            {editDropdownOpen && (
              <ul className="dropdown-content">
                <li><Link to="/add-heading-2" onClick={closeSidebar}>Add Heading 2</Link></li>
                <li><Link to="/add-heading" onClick={closeSidebar}>Add Heading </Link></li>
                <li><Link to="/add-material" onClick={closeSidebar}>Add & Edit Material</Link></li>
                <li><Link to="/add-formula" onClick={closeSidebar}>Add Formula</Link></li>
                <li><Link to="/edit-formula" onClick={closeSidebar}>Edit Formula</Link></li>
              </ul>
            )}
          </li>
        </ul>
      </aside>

      {isOpen && <div className="overlay" onClick={closeSidebar}></div>}
    </>
  );
};

export default Sidebar;
